import { PaymentGatewayIntegration } from '../..';

import cvc from '../../components/elements/cvc.vue';
import creditCard from '../../components/elements/creditCard.vue';
import expiry from '../../components/elements/expiry.vue';

export default class StripeSimple extends PaymentGatewayIntegration {
    public name = 'StripeSimple';
    public scriptUrl = 'https://js.stripe.com/v2/';
    public fields = {
        cvc,
        creditCard,
        expiry,
    };

    public integrationFields = {
        stripe: {},
    };

    public async created() {
        await this.loadScript();
        if (!window.Stripe) {
            this.vm.failed = true;
        }

        this.integrationFields.stripe = window.Stripe;
        (this.integrationFields.stripe as any).setPublishableKey(this.integrationData.publishable_key);

        this.vm.loading = false;
    }

    public async serialize(additionalsGot: any) {
        const validation = this.vm.validate(true);
        const keyMatch = {
            exp_year: 'expiry',
            exp_month: 'expiry',
            number: 'creditCard',
            cvc: 'cvc',
        };
        if (validation.isValid) {
            const expiryData = this.vm.form.expiry.value.split('/');
            const additionals = this.preSerialize(additionalsGot);
            const data: any = await new Promise((resolve) => {
                try {
                    (this.integrationFields.stripe as any).card.createToken({
                        number: this.vm.form.creditCard.value,
                        cvc: this.vm.form.cvc.value,
                        exp_month: expiryData[+'0'].trim(),
                        exp_year: expiryData[+'1'].trim(),
                        ...additionals,
                    }, (status, response) => {
                        resolve(response);
                    });
                } catch (response) {
                    resolve(response);
                }
            });
            if (!data.error) {
                return this.postSerialize(additionalsGot, {
                    token_data: data.id,
                    token_card: data.card,
                });
            } else {
                validation.isValid = false;
                validation.commonError = data.error.message;

                const param = data.error.param || '';
                const key = keyMatch[param];
                if (key) {
                    validation.validation[key] = false;
                    (this.vm.$refs[key] as any).valid = false;
                    (this.vm.$refs[key] as any).$emit('valid', false);
                }
                throw validation;
            }
        } else {
            throw validation;
        }
    }
}
